import Theme from '@adsk/alloy-react-theme';

export const errorLoadingProductsContainer = {
  marginTop: '48px',
  textAlign: 'center',
};

export const errorLoadingProductsHeader = {
  ...Theme.typography.heading2,
  paddingBottom: '12px',
};

export const errorLoadingProductsBody = {
  ...Theme.typography.labelMedium,
  color: Theme.colors.adskBlue700,
};
